<template>
  <div class="touyanbaogao-layer">
    <caseheader></caseheader>

    <div v-if="step == 1" class="content-wrap-welcome" :class="isCJTY == 0 ? 'content-wrap-zc' : 'content-wrap-cjty'">
      <div class="flex-box">
        <div class="welcome">
          <p>您好！</p>
          <p>投研报告助手可以为您提供专业的投研报告服务</p>
          <p>请问您的需求重点是？</p>
        </div>
        <div class="main-xuanxian-welcome">
          <div class="line-top">
            <div class="gnpz" @click="openGNPZ"><i class="el-icon-setting"></i>功能配置</div>
          </div>
          <div class="line-center">
            <div class="line1">已实现功能点：</div>
            <div class="line2">
              <div class="line2-left">
                <div class="box" :class="type == item.id ? 'active' : ''" @click="onClicktype(item.id)"
                     v-for="item in FunctionPoints" :key="item.id">{{ item.btnName }}</div>
                <!-- <div class="box" :class="type == 1 ? 'active' : ''" @click="onClicktype(1)">完整报告</div>
                <div class="box" :class="type == 2 ? 'active' : ''" @click="onClicktype(2)">消费者行为变迁洞察</div>
                <div class="box" :class="type == 3 ? 'active' : ''" @click="onClicktype(3)">行业政策风险评估</div>
                <div class="box" :class="type == 4 ? 'active' : ''" @click="onClicktype(4)">行业研究方法拓展</div>
                <div class="box" :class="type == 5 ? 'active' : ''" @click="onClicktype(5)">个股分析报告</div>
                <div class="box" :class="type == 6 ? 'active' : ''" @click="onClicktype(6)">供应链稳定性评估</div>
                <div class="box" :class="type == 7 ? 'active' : ''" @click="onClicktype(7)">关键事件影响分析</div>
                <div class="box" :class="type == 8 ? 'active' : ''" @click="onClicktype(8)">投研方法论反思</div> -->
              </div>
            </div>
          </div>
        </div>

        <!-- 语音浮动版 -->
        <div class="sample-view" v-show="sampleShow">
          <img src="../zhinengkefu/imgs/sample.gif">
          <!-- <span>（R键快捷发送，S键取消）</span> -->
          <el-button class="sendBtn" size="mini" @click="handleSampleSend">发送</el-button>
          <el-button class="closeBtn" size="mini" @click="handleSampleClose">取消</el-button>
        </div>

        <!-- 发送框 -->
        <div class="sendBox sendBox-width1" :class="{ 'disabled': loading }">
          <el-input ref="input" placeholder="向AI投研助手发送消息..." v-model="input" :disabled="loading"
                    @keyup.enter.native="handleSend(input)"></el-input>
          <div class="btn-inner">
            <microphone v-if="YYType === 1" class="huatong" ref="microphone" @start="onMicrophoneStart"
                        @end="onMicrophoneEnd"></microphone>
            <XFDictation v-else-if="YYType === 2" class="huatong" ref="microphone" @start="onMicrophoneStart"
                         @end="onMicrophoneEnd"></XFDictation>
          </div>
          <div class="btn-inner">
            <div class="sendBtn" @click="handleSend(input)"><img src="../zhinengkefu/imgs/fasong-2_1@2x.png"></div>
          </div>
        </div>
      </div>
    </div>
    <div v-else class="content-wrap" :class="isCJTY == 0 ? 'content-wrap-zc' : 'content-wrap-cjty'">
      <div class="main-layer">
        <!-- <div v-if="type == 1" class="main-content" :class="result ? 'hascontent' : 'nocontent'" v-loading="loading"
             element-loading-text="大模型正在思考中,预计需要2分钟..." element-loading-spinner="el-icon-loading"
             element-loading-background="rgba(0, 0, 0, 0.7)">
          <VueMarkdown :source="result" />
        </div>
        <div v-else class="main-content nocontent" v-loading="loading" element-loading-text="大模型正在思考中,预计需要2分钟..."
             element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.7)">
          <VueMarkdown :source="result" />
        </div> -->
        <div class="main-content" :class="result ? 'hascontent' : 'nocontent'">
          <ul ref="dialogBox" :class="{ 'isSample': sampleShow }">
            <li v-for="(item, index) in msgList" :key="index"
                :class="{ 'isMy': item.isMy, 'isSample': item.type == 2 }">
              <div class="msg-inner">
                <div class="pic">
                  <img v-if="item.isMy" src="../zhinengkefu/imgs/Group_242@2x.png">
                  <img v-else src="../zhinengkefu/imgs/ac4856.png">
                </div>
                <div class="text" v-show="!item.loading">
                  <p>{{ item.isMy ? '用户' : '投研报告助手' }}</p>
                  <!-- <span class="msg">{{ item.text }}</span> -->
                  <VueMarkdown :ref="'VueMarkdown' + index" :source="item.text" class="msg" />
                  <div class="upload-view" v-if="item.isPDF">
                    <img src="~@imgs/touyanbaogao/组 16269.png" style="width: 23px;height: 28px;" />
                    <button @click="getPdf(index)">下载报告</button>
                  </div>
                </div>
                <div class="text" v-show="item.loading">
                  <span class="el-icon-loading"></span>
                </div>
              </div>
            </li>
          </ul>
          <!-- <VueMarkdown :source="result" /> -->
        </div>
        <!-- <div v-else class="main-content nocontent">
          <zdyloading style="position: absolute;top: 0;left: 0;" ref="zdyloading" :isShowLoading="loading"
                      loadingTxt="大模型正在思考中,预计需要2分钟...">
          </zdyloading>
          <VueMarkdown :source="result" />
        </div> -->
        
        <div style="width: 100%;">
          <!-- <div class="main-pdf" v-show="result" @click="downloadPDF"> -->
          <!-- <div class="main-pdf" v-show="result && type == 1" @click="lookPDF">
            <div class="pdf-left">
              <img src="~@imgs/touyanbaogao/组 16269.png" style="width: 23px;height: 28px;" />
            </div>
            <div class="pdf-right">
              <p>{{ filename }}.pdf</p>
            </div>
          </div> -->
          <div class="main-xuanxian" v-if="!loading">
            <div class="line-left">
              <div class="line1">已实现功能点：</div>
              <div class="line2">
                <div class="line2-left">
                  <div class="box" :class="type == item.id ? 'active' : ''" @click="onClicktype(item.id)"
                       v-for="item in FunctionPoints" :key="item.id">{{ item.btnName }}</div>
                  <!-- <div class="box" :class="type == 1 ? 'active' : ''" @click="onClicktype(1)">完整报告</div>
                  <div class="box" :class="type == 2 ? 'active' : ''" @click="onClicktype(2)">消费者行为变迁洞察</div>
                  <div class="box" :class="type == 3 ? 'active' : ''" @click="onClicktype(3)">行业政策风险评估</div>
                  <div class="box" :class="type == 4 ? 'active' : ''" @click="onClicktype(4)">行业研究方法拓展</div>
                  <div class="box" :class="type == 5 ? 'active' : ''" @click="onClicktype(5)">个股分析报告</div>
                  <div class="box" :class="type == 6 ? 'active' : ''" @click="onClicktype(6)">供应链稳定性评估</div>
                  <div class="box" :class="type == 7 ? 'active' : ''" @click="onClicktype(7)">关键事件影响分析</div>
                  <div class="box" :class="type == 8 ? 'active' : ''" @click="onClicktype(8)">投研方法论反思</div> -->
                </div>
              </div>
              <!-- <div class="line2-right">
                <div class="gnpz" @click="openGNPZ">功能配置</div>
              </div> -->
            </div>
            <div class="line-right">
              <div class="gnpz" @click="openGNPZ"><i class="el-icon-setting"></i>功能配置</div>
            </div>
          </div>
          <div class="main-xuanxian" v-else>
            <div class="line-left">
              <div class="line1">已实现功能点：</div>
              <div class="line2">
                <div class="line2-left">
                  <div class="box-no" :class="type == item.id ? 'active' : ''" v-for="item in FunctionPoints"
                       :key="item.id">{{ item.btnName }}</div>
                  <!-- <div class="box-no" :class="type == 1 ? 'active' : ''">完整报告</div>
                  <div class="box-no" :class="type == 2 ? 'active' : ''">消费者行为变迁洞察</div>
                  <div class="box-no" :class="type == 3 ? 'active' : ''">行业政策风险评估</div>
                  <div class="box-no" :class="type == 4 ? 'active' : ''">行业研究方法拓展</div>
                  <div class="box-no" :class="type == 5 ? 'active' : ''">个股分析报告</div>
                  <div class="box-no" :class="type == 6 ? 'active' : ''">供应链稳定性评估</div>
                  <div class="box-no" :class="type == 7 ? 'active' : ''">关键事件影响分析</div>
                  <div class="box-no" :class="type == 8 ? 'active' : ''">投研方法论反思</div> -->
                </div>
              </div>
              <!-- <div class="line2-right">
                <div class="gnpz" @click="openGNPZ" v-if=isShowGNPZBtn>功能配置</div>
              </div>  -->
            </div>
            <div class="line-right">
              <div class="gnpz" @click="openGNPZ"><i class="el-icon-setting"></i>功能配置</div>
            </div>
          </div>
          <div class="main-input2">
            <!-- 语音浮动版 -->
            <div class="sample-view" v-show="sampleShow">
              <img src="../zhinengkefu/imgs/sample.gif">
              <!-- <span>（R键快捷发送，S键取消）</span> -->
              <el-button class="sendBtn" size="mini" @click="handleSampleSend">发送</el-button>
              <el-button class="closeBtn" size="mini" @click="handleSampleClose">取消</el-button>
            </div>

            <!-- 发送框 -->
            <div class="sendBox sendBox-width2" :class="{ 'disabled': loading }">
              <el-input ref="input" placeholder="向AI投研助手发送消息..." v-model="input" :disabled="loading"
                        @keyup.enter.native="handleSend(input)"></el-input>
              <div class="btn-inner">
                <microphone v-if="YYType === 1" class="huatong" ref="microphone" @start="onMicrophoneStart"
                            @end="onMicrophoneEnd"></microphone>
                <XFDictation v-else-if="YYType === 2" class="huatong" ref="microphone" @start="onMicrophoneStart"
                             @end="onMicrophoneEnd"></XFDictation>
              </div>
              <div class="btn-inner">
                <div class="sendBtn" @click="handleSend(input)"><img src="../zhinengkefu/imgs/fasong-2_1@2x.png"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="right-layer">
        <!--如果是完整内容-->
        <div class="pdf-top" v-show="pdflist.length > 0 && type == 1">
          <!-- <div class="pdf-name">
            <p>{{ pdfname }}</p>
            <span @click="xiazai"
                  style="color: #49f0ff;font-size: 0.12rem;cursor: pointer;margin-top: 4px;">导出为pdf</span>
          </div> -->
          <div class="pdf-list">
            <!-- <div v-if="pdflist.length >= 3"
               style="width: 0.25rem;height: 0.25rem;background: #84b5ff;border-radius: 50%;display: flex;align-items: center;justify-content: center;margin-right: 0.1rem;cursor: pointer;">
            <i class="el-icon-caret-left" style="color: #fff;"></i>
          </div> -->
            <!-- <div class="pdf-box" v-for="item in pdflist" :key="item.id" @click="onClickShowPDF(item)">
              <img src="~@imgs/touyanbaogao/1111.png" style="width: 24px;height: 24px;display: block;" />
              <p class="wz">{{ item.filename }}</p>
            </div> -->
            <!-- <div v-if="pdflist.length < 3"
               style="width: 0.25rem;height: 0.25rem;background: #84b5ff;border-radius: 50%;display: flex;align-items: center;justify-content: center;margin-left: 0.1rem;cursor: pointer;">
            <i class="el-icon-caret-right" style="color: #fff;"></i>
          </div> -->
          </div>
        </div>

        <!--如果是完整内容-->
        <div v-show="pdflist.length > 0 && type == 1" class="pdflook printContent" style="height: calc(100% - 1.3rem);"
             ref="printContent">
          <!-- 这里是内容 -->
          <VueMarkdown :source="pdfresult" />
        </div>

        <!--如果是部分内容-->
        <div v-if="type" class="pdflook printContent part" style="height: 100%;" ref="printContent">
          <!-- 这里是内容 -->
          <VueMarkdown :source="partpdfresult" />
        </div>
      </div>
    </div>
    <gongnengpeizhiDialog ref="gongnengpeizhiDialog" @updateSetting="updateSetting"></gongnengpeizhiDialog>
    <!-- <zdyloading style="position: absolute;top: 0;left: 0;" ref="zdyloading" :isShowLoading="loading"
                loadingTxt="大模型正在思考中,预计需要2分钟...">
    </zdyloading> -->
    
    <div class="dd-inner" v-show="loading">
      <zdyloading style="width: 200px;" ref="zdyloading"
                  :isShowLoading="loading" loadingTxt="大模型正在思考中,预计需要2分钟...">
      </zdyloading>
    </div>
  </div>
</template>

<script>
import microphone from '../zhinengkefu/components/microphone/microphone.vue'
import XFDictation from '../zhinengkefu/components/XFDictation/index.vue'
import gongnengpeizhiDialog from './gongnengpeizhiDialog.vue'
import VueMarkdown from 'vue-markdown'
import printPDF from '@/utils/printPDF'
import axios from 'axios'
import Zdyloading from '@/components/Zdyloading.vue'
import Caseheader from '@/components/layout/caseheader.vue'
axios.defaults.timeout = 300000
axios.defaults.withCredentials = false
axios.defaults.headers['Content-Type'] = 'application/json;charset=utf-8'

export default {
  name: '',
  components: { microphone, XFDictation, VueMarkdown, gongnengpeizhiDialog, Zdyloading, Caseheader },
  props: {},
  data () {
    return {
      step: 1,
      apiUrl: window.FastGptApiUrl + '/api/v1/chat/completions',
      loading: false,
      input: '', //输入框
      chatnum: null, //当前对话窗口
      type: 1,
      result: '',
      filename: '', //文件名称
      pdfurl: '',
      pdfname: '', //当前pdf名称
      pdfresult: '', //当前打开的pdf内容
      pdflist: [], //
      downloading: null,
      // 打印中
      print: false,
      isCJTY: 0,
      partpdfresult: '',
      msgList: [], // 对话列表
      sampleShow: false, // 语音浮动板块显隐
      // 使用语音服务：1=阿里云、2=讯飞
      YYType: window.YYType || 1,
      isSetting: false,//是否进行了功能配置
      FunctionPoints: [],//已有的功能点
    }
  },
  computed: {
    //是否显示功能配置按钮，第一次默认进来时不展示，当缓存保存的值有数据时再展示
    isShowGNPZBtn () {
      return false
    }
  },
  watch: {
    msgList (newVal, oldVal) {
      let dom = this.$refs['dialogBox']
      if (dom && newVal.length) {
        setTimeout(() => {
          dom.scrollTop = 9999999
        }, 100)
      }
    }
  },
  created () {
    //初始进入时，判断是否有保存的配置，若有，取功能配置里的，若无，取默认系统里的
    let znty_save_list = sessionStorage.getItem('znty_save_list')
    console.log("znty_save_list>>>", znty_save_list);
    if (znty_save_list) {
      this.isSetting = true
      console.log('有做配置');
      let json_znty_save_list = JSON.parse(znty_save_list)
      console.log("json_znty_save_list???", json_znty_save_list);
      this.FunctionPoints = json_znty_save_list
    } else {
      this.isSetting = false
      console.log('取系统默认的');
      //拉取固定智能投研key列表
      let znty_list = [
        {
          "id": 1,
          "btnName": "完整报告",
          "btnKey": window.CJTY_TYBG_TOKEN
        },
        {
          "id": 2,
          "btnName": "消费者行为变迁洞察",
          "btnKey": window.CJTY_TYBGZNT_XFZXWBQDC_TOKEN
        }
      ]
      sessionStorage.setItem('znty_list', JSON.stringify(znty_list))
      this.FunctionPoints = znty_list
    }

  },
  mounted () {
    this.FunctionPoints.some(item => {
      if (item.id == this.type) {
        sessionStorage.setItem('tybg_key', item.btnKey)
        return true
      }
    })

    let pdflist = sessionStorage.getItem('pdflist') || []
    if (pdflist.length !== 0) {
      let pdflistobj = JSON.parse(pdflist)
      this.pdflist = pdflistobj
      // console.log('pdflist>>>', pdflist)

      this.input = pdflistobj[0].name
      this.result = pdflistobj[0].content
      this.filename = pdflistobj[0].filename
      this.pdfurl = pdflistobj[0].pdfurl
      this.pdfresult = pdflistobj[0].content
      this.pdfname = pdflistobj[0].filename
    }
  },
  beforeDestroy () {
    sessionStorage.removeItem('pdflist')
  },
  methods: {
    //配置弹窗完成配置后， 更新主组件内容
    updateSetting (val) {
      // alert('更新了')
      let znty_save_list = sessionStorage.getItem('znty_save_list')
      console.log("znty_save_list>>>", znty_save_list);
      if (znty_save_list) {
        this.isSetting = true
        console.log('有做配置');
        let json_znty_save_list = JSON.parse(znty_save_list)
        console.log("json_znty_save_list???", json_znty_save_list);
        this.FunctionPoints = json_znty_save_list
      }
    },
    
    // 发送, str：问题, type：1文字，2语音文字
    handleSend (str, type) {
      console.log("str>>>", str);
      console.log("type>>>", type);
      this.step = 2
      this.msgList.push(
        {
          isMy: true,
          text: str,
          loading: false
        })
      this.getdata()
      this.input = ''
    },
    // 语音：监听开始
    onMicrophoneStart () {
      clearTimeout(this.timer)
      this.timer = setTimeout(() => {
        this.sampleShow = true
      }, 100)
    },

    // 语音：监听完毕
    onMicrophoneEnd () {
      this.sampleShow = false
    },

    // 语音：确定发送
    handleSampleSend () {
      clearTimeout(this.timer1)
      this.timer1 = setTimeout(() => {
        this.$refs['microphone'].send && this.$refs['microphone'].send((data) => {
          console.log(data)
          if (data) {
            for (var i = 0; i < data.length; i++) {
              if (!data[i]) {
                data.splice(i, 1)
                i++
              }
            }
            let str = data.join('')
            this.handleSend(str, 2)
          }
        })
      }, 500)
    },

    // 语音：取消发送
    handleSampleClose () {
      this.$refs['microphone'].stop && this.$refs['microphone'].stop()
    },
    
    //打开功能配置
    openGNPZ () {
      this.$refs.gongnengpeizhiDialog.show()
    },
    
    xiazai () {
      window.open(this.pdfurl)
      // this.downloading = this.$loading()
      // this.print = true
      // setTimeout(() => {
      //   this.getPdf()
      // }, 1500)
    },
    
    getPdf (index) {
      let A4_WIDTH = 592.28
      let A4_HEIGHT = 841.89
      let target = this.$refs['VueMarkdown' + index][0].$el
      let pageHeight = (target.scrollWidth / A4_WIDTH) * A4_HEIGHT
      let targetClone = null
      
      if(target.querySelectorAll('#targetClone' + index)?.length){
        targetClone = target.querySelector(`#targetClone${index} .msg`)
      } else {
        targetClone = target.cloneNode(true)
        let box = document.createElement('div')
        box.id = 'targetClone' + index
        targetClone.setAttribute(
          'style',
          `color: #000000; padding: 10px; width: ${A4_WIDTH}px; height: auto;`
        )
        box.setAttribute(
          'style',
          'width: 0; height: 0; overflow: hidden;'
        )
        box.appendChild(targetClone)
        target.appendChild(box)
      }
      
      printPDF(targetClone, this.filename).then(res => {
        this.downloading.close()
        this.print = false
      }).catch(() => {
        this.downloading.close()
        this.print = false
      })
    },
    
    // 判断是否需要添加空白div
    isSplit(nodes, index, pageHeight) {
      // 计算当前这块dom是否跨越了a4大小，以此分割
      if (
        nodes[index].offsetTop + nodes[index].offsetHeight < pageHeight
        && nodes[index + 1]
        && nodes[index + 1].offsetTop + nodes[index + 1].offsetHeight > pageHeight
      ) {
        return true
      }
      return false
    },
    
    onClickShowPDF (item) {
      this.pdfurl = item.pdfurl
      this.pdfresult = item.content
      this.pdfname = item.filename
    },
    downloadPDF () {
      window.open(this.pdfurl)
    },
    lookPDF () {
      console.log('this.type', this.type)
    },
    getdata () {
      //默认取演示投研报告的token
      let tybg_key = sessionStorage.getItem('tybg_key')

      if (!tybg_key) {
        this.$message.warning('请先完成API秘钥配置！')
        return
      } else {
        this.loading = true
        this.msgList.push({
          isMy: false,
          text: '...',
          loading: true
        })
        axios({
          headers: {
            'Authorization': `Bearer ${tybg_key}`
          },
          url: this.apiUrl,
          method: 'POST',
          data: {
            "stream": false,
            "detail": false,
            "chatId": sessionStorage.getItem('dygptaccount'),
            "variables":
            {
              "input": this.input,
            },
            "messages": [
              {
                "role": "user",
                'content': "123"
              }
            ]

          }
        }).then(res => {
          this.loading = false
          if (res?.data && (res.status == 200 || res.status == 304)) {
            let data = res.data
            console.log("DATA>>>", data);

            if (data.code == 514 || data.code == 403) {
              this.$alert('模块工作流API秘钥不正确，请检查！')
              this.msgList = []
              return
            } else {
              // let text = data.choices[0].message.content || ''
              //如果是完整报告
              // if (this.type == 1) {
              //   this.result = data.choices[0].message.content || ''
              //   console.log("this.result>>>", this.result);
              //   this.msgList[this.msgList.length - 1] = {
              //     isMy: false,
              //     text: data.choices[0].message.content || '',
              //     loading: false
              //   }

              //   let dizhi = this.result.split('[下载链接]')[1].split('[文件名称]')[0].replace('(', '').replace(')', '')
              //   console.log('dizhi>>>', dizhi)
              //   let filename = this.result.split('[下载链接]')[1].split('[文件名称]')[1]
              //   console.log('文件名称》》', filename)
              //   // this.getDocx()
              //   this.filename = filename
              //   this.pdfurl = dizhi
              //   // this.$refs['PDFReader'].loadFile(this.pdfurl)
              //   //---------------------
              //   this.pdfresult = this.result
              //   var currentTime = new Date().toLocaleTimeString()
              //   let date = new Date()
              //   let month = date.getMonth() + 1 // 月份是从0开始的，所以需要加1
              //   let day = date.getDate()
              //   let time = month + '/' + day + ' ' + currentTime
              //   this.pdfname = filename
              //   let obj = [{
              //     id: this.chatnum, name: this.input, time: time, filename: filename, pdfurl: dizhi, content: this.result
              //   }]
              //   console.log('obj>>>', obj)
              //   // let newpdflist = [...this.pdflist, ...obj]
              //   // sessionStorage.setItem('pdflist', JSON.stringify(newpdflist))
              //   console.log('this.pad', newpdflist)
              //   this.pdflist = newpdflist
              // }
              // else {
                //如果是单独报告时
                let msg = data.choices[0].message.content || ''
                let newmsg = msg
                if(newmsg.indexOf('</think>') > -1){
                  newmsg = newmsg.split('</think>')[1]
                }
                this.result = newmsg
                this.partpdfresult = newmsg

                this.msgList[this.msgList.length - 1] = {
                  isMy: false,
                  text: newmsg,
                  loading: false,
                  isPDF: true
                }
              // }
            }
          }
        }).catch((err) => {
          console.log("Err>>>", err);
          this.$alert('当前网络连接错误，请检查后再试')
          this.loading = false
        })
      }
    },

    //切换类型
    onClicktype (type) {
      this.result = ''
      this.type = type
      this.FunctionPoints.forEach(item => {
        if (item.id == this.type) {
          sessionStorage.setItem('tybg_key', item.btnKey)
        }
      })
    },
  }
}
</script>

<style scoped lang="less">
.wz {
  width: 100px;
  /* 容器宽度 */
  white-space: nowrap;
  /* 防止文本换行 */
  overflow: hidden;
  /* 隐藏溢出的内容 */
  text-overflow: ellipsis;
  /* 使用省略号表示溢出的文本 */
}

/deep/::-webkit-scrollbar {
  /*滚动条整体样式*/
  width: 4px;
  height: 4px;
}

/deep/::-webkit-scrollbar-thumb {
  /*滚动条里面小方块*/
  border-radius: 7px;
  background-image: linear-gradient(to right, #f5f5f5, #fff);
  box-shadow: inset 0 0 5px rgba(249, 255, 254, 0.8);
  border: 1px solid #d5d5d5;
}

/deep/::-webkit-scrollbar-track {
  /*滚动条里面轨道*/
  box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.3);
  // background: #d5d5d5;
  background: #f5f9ff;
  margin: 1px 0;
  border-radius: 7px;
}

.touyanbaogao-layer {
  height: 100%;
  display: flex;
  flex-direction: column;

  .content-top {
    height: 60px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    background-color: #f3faff;
    padding: 0 40px;
    border-bottom: 1px solid rgba(0, 0, 0, 0.16);

    .top-left {
      display: flex;
      align-items: center;

      .title {
        font-size: 16px;
        margin-right: 0.2rem;
      }
    }

    .top-right {
      display: flex;

      .l-btn-3 {
        width: 139px;
        height: 40px;
        line-height: 40px;
        background: #fff;
        border-radius: 9px;
        color: #666666;
        font-weight: bold;
        text-align: center;
        cursor: pointer;
        margin-right: 20px;
      }

      .r-btn-miaoshu {
        width: 139px;
        height: 40px;
        line-height: 40px;
        background: #fff;
        border-radius: 9px;
        color: #666666;
        font-weight: bold;
        text-align: center;
        cursor: pointer;
        margin-right: 20px;

        &:hover {
          filter: hue-rotate(20deg) brightness(100%);
        }
      }

      .r-btn-jiaojuan {
        width: 139px;
        height: 40px;
        line-height: 40px;
        background: linear-gradient(90deg, #76E8FE 0%, #2187EC 100%);
        border-radius: 9px;
        color: #fff;
        font-weight: bold;
        text-align: center;
        cursor: pointer;

        &:hover {
          filter: hue-rotate(20deg) brightness(100%);
        }
      }
    }
  }

  .content-wrap-cjty {
    height: 100%;
  }

  .content-wrap-zc {
    height: calc(100% - 60px);
    color: #fff;
  }

  .content-wrap-welcome {
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    align-content: center;
    justify-content: flex-start;
    margin-top: 1rem;
    margin: 0 auto;

    .flex-box {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: flex-start;
      padding: 0.4rem;
      border-radius: 0.25rem;
      background-color: rgba(52, 87, 135, 0.6);
      box-sizing: border-box;
      overflow: hidden;
      border: 1px solid rgba(255, 255, 255, 0.2);
      box-shadow: 0 0 25px -2px rgba(130, 180, 255, 0.2) inset;
      margin-top: 1rem;
    }

    .welcome {
      width: 7.5rem;

      p {
        font-size: 24px;
        font-weight: 500;
      }
    }

    .main-xuanxian-welcome {
      width: calc(100% - 0.4rem);
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      margin-bottom: 0.5rem;

      .line-center {
        width: 7.5rem;
        height: 100%;
        background: #FFFFFF;
        box-shadow: 0px 3px 6px 1px rgba(0, 0, 0, 0.16);
        border-radius: 0.15rem;
        padding: 0.2rem;
        box-sizing: border-box;

        .line1 {
          color: #385A90;
          margin-bottom: 0.1rem;
        }

        .line2 {
          margin-bottom: 0.1rem;
          width: 100%;
          display: flex;
          align-items: center;

          .line2-left {
            display: flex;
            align-items: center;
            flex-wrap: wrap;
            width: 100%;
            max-height: 1rem;
            overflow: auto;

            .box {
              min-width: 1.5rem;
              height: 0.33rem;
              line-height: 0.33rem;
              background: #fff;
              border: 1px solid #84B5FF;
              border-radius: 0.05rem;
              display: flex;
              justify-content: center;
              align-items: center;
              // margin-right: 0.4rem;
              margin-right: 0.1rem;
              margin-bottom: 0.05rem;
              cursor: pointer;
              color: #84B5FF;
              padding: 0 8px;
              padding: 0 .1rem;
            }

            .box-no {
              min-width: 1.5rem;
              height: 0.33rem;
              line-height: 0.33rem;
              background: #fff;
              border: 1px solid #84B5FF;
              color: #84b5ff;
              border-radius: 0.05rem;
              display: flex;
              justify-content: center;
              align-items: center;
              // margin-right: 0.4rem;
              margin-right: 0.1rem;
              margin-bottom: 0.05rem;
              cursor: not-allowed;
              opacity: 0.5;
              padding: 0 .1rem;
            }

            .active {
              border: none;
              background: #84b5ff;
              color: #fff;
            }
          }

        }
      }

      .line-top {
        width: 7.5rem;
        height: 100%;
        display: flex;
        justify-content: flex-end;
        align-items: flex-start;
        margin-bottom: 0.1rem;

        .gnpz {
          // width: 1.4rem;
          width: 1.4rem;
          height: 0.4rem;
          line-height: 0.4rem;
          background: linear-gradient(90deg, #76E8FE 0%, #2187EC 100%);
          border-radius: 9px;
          color: #fff;
          font-weight: bold;
          text-align: center;
          cursor: pointer;
          // margin: 0 auto;
          // margin-left: 0.2rem;


          &:hover {
            filter: hue-rotate(20deg) brightness(100%);
          }
        }

      }
    }

  }

  .content-wrap {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    // height: 100%;

    .main-layer {
      width: calc(100% - 6.1rem);
      height: calc(100% - 0.5rem);
      padding: 0.2rem;
      box-sizing: border-box;
      overflow: hidden;
      background-color: rgba(52, 87, 135, 0.6);
      border: 1px solid rgba(255, 255, 255, 0.2);
      box-shadow: 0 0 25px -2px rgba(130, 180, 255, 0.2) inset;
      border-radius: 0.15rem;
      margin-right: .2rem;
      display: flex;
      flex-wrap: wrap;
      align-content: space-between;

      .main-content {
        position: relative;
        width: 100%;
        height: calc(100% - 2.8rem);
        margin-bottom: auto;

        ul {
          height: 95%;
          margin: 0;
          overflow: auto;
          padding: 0;
          padding-right: 10px;
          box-sizing: border-box;

          li {
            margin-top: 10px;
            margin-bottom: 30px;
            font-size: 16px;
            min-height: 50px;

            &.isSample .text p::before {
              font-family: element-icons !important;
              content: "\e727";
              margin-right: 2px;
              color: #66b2d5;
            }

            .msg-inner {
              display: inline-block;
              padding-left: 60px;
              position: relative;
              max-width: 60%;
              min-width: 300px;

              .pic {
                width: 50px;
                height: 50px;
                position: absolute;
                left: 0;

                img {
                  width: 100%;
                  height: 100%;
                }
              }

              .text {
                position: relative;
                font-size: 16px;
                word-wrap: break-word;

                p {
                  color: #afafaf;
                  margin-bottom: 5px;
                  margin-top: 5px;
                  user-select: none;
                }

                span {
                  line-height: 1.4;
                }

                .el-icon-loading {
                  margin-top: 12px;
                  font-size: 20px;
                  color: #999;
                  margin-left: 10px;
                }
              }
            }

            &.isMy {
              text-align: right;
              padding-left: 0;

              .msg-inner {
                padding: 0;
                padding-right: 60px;
              }

              .pic {
                position: absolute;
                left: auto;
                right: 0;
              }

              .msg {
                text-align: left;
                display: inline-block;
              }
            }
          }
        }

        /deep/p,
        h1,
        h2,
        h3,
        h4,
        h5,
        h6,
        div,
        li,
        tr {
          line-height: 2 !important;
        }
      }

      .main-pdf {
        width: 2.4rem;
        height: 0.34rem;
        display: flex;
        align-items: center;
        background: #FFFFFF;
        border-radius: 0.15rem;
        border: 1px solid #A0C2F6;
        padding: 0.1rem;
        cursor: pointer;
        margin-bottom: 0.1rem;

        .pdf-left {
          margin-right: 0.1rem;
        }

        .pdf-right {
          display: flex;
          flex-direction: column;
          justify-content: center;
          height: 80%;

          p {
            font-size: 0.16rem;
            color: #385A90;
          }
        }
      }

      .main-xuanxian {
        width: 100%;
        height: 1rem;
        display: flex;

        .line-left {
          width: calc(100% - 2rem);
          height: 100%;
          background: #FFFFFF;
          box-shadow: 0px 3px 6px 1px rgba(0, 0, 0, 0.16);
          border-radius: 0.15rem;
          padding: 0.2rem;

          .line1 {
            color: #385A90;
            margin-bottom: 0.1rem;
          }

          .line2 {
            margin-bottom: 0.1rem;
            width: 100%;
            display: flex;
            align-items: center;

            .line2-left {
              display: flex;
              align-items: center;
              flex-wrap: wrap;
              width: 100%;
              max-height: 1rem;
              overflow: auto;

              .box {
                min-width: 1.5rem;
                height: 0.33rem;
                line-height: 0.33rem;
                background: #fff;
                border: 1px solid #84B5FF;
                border-radius: 0.05rem;
                display: flex;
                justify-content: center;
                align-items: center;
                // margin-right: 0.4rem;
                margin-right: 0.1rem;
                margin-bottom: 0.05rem;
                cursor: pointer;
                color: #84B5FF;
                padding: 0 .1rem;
              }

              .box-no {
                min-width: 1.5rem;
                height: 0.33rem;
                line-height: 0.33rem;
                background: #fff;
                border: 1px solid #84B5FF;
                color: #84b5ff;
                border-radius: 0.05rem;
                display: flex;
                justify-content: center;
                align-items: center;
                // margin-right: 0.4rem;
                margin-right: 0.1rem;
                margin-bottom: 0.05rem;
                cursor: not-allowed;
                opacity: 0.5;
                padding: 0 .1rem;
              }

              .active {
                border: none;
                background: #84b5ff;
                color: #fff;
              }
            }

          }
        }

        .line-right {
          width: 2rem;
          height: 100%;
          display: flex;
          justify-content: flex-end;
          align-items: flex-end;
          padding: 0.2rem 0 0 0;
          margin-top: 0.2rem;

          .gnpz {
            width: 1.5rem;
            height: 0.4rem;
            line-height: 0.4rem;
            background: linear-gradient(90deg, #76E8FE 0%, #2187EC 100%);
            border-radius: 9px;
            color: #fff;
            font-weight: bold;
            text-align: center;
            cursor: pointer;
            margin-left: 0.2rem;

            &:hover {
              filter: hue-rotate(20deg) brightness(100%);
            }
          }

        }
      }

      .main-input2 {
        width: 100%;
        margin-top: 0.6rem;
      }

      .main-input {
        width: calc(100% - 0.2rem);
        height: 1.6rem;
        position: relative;
        background: #FFFFFF;
        border-radius: 0.15rem;
        border: 1px solid #A0C2F6;
        padding: 0.1rem;
        // margin-top: 0.2rem;
        margin-top: 0.6rem;

        /deep/.el-textarea__inner {
          border: none !important;
        }

        .main-zanting {
          position: absolute;
          bottom: 0.2rem;
          right: 0.6rem;
          cursor: pointer;

          i {
            color: red;
            font-size: 0.35rem;
          }
        }

        .main-fasong {
          position: absolute;
          bottom: 0.2rem;
          right: 0.2rem;

          img {
            width: 35px;
            height: 35px;
            display: block;
            cursor: pointer;
            z-index: 999;
          }
        }

        .main-fasong-no {
          position: absolute;
          bottom: 0.2rem;
          right: 0.2rem;

          img {
            width: 35px;
            height: 35px;
            display: block;
            cursor: not-allowed;
            z-index: 999;
          }
        }
      }
    }

    .right-layer {
      // width: 5.2rem;
      // height: 100%;
      width: 5rem;
      height: calc(100% - 0.5rem);
      padding: 0.1rem;
      background-color: rgba(52, 87, 135, 0.6);
      border: 1px solid rgba(255, 255, 255, 0.2);
      box-shadow: 0 0 25px -2px rgba(130, 180, 255, 0.2) inset;
      border-radius: 0.15rem;
      box-sizing: border-box;

      .pdf-top {
        height: 1rem;
        margin: 0.15rem 0;
        overflow: auto;
        display: flex;
        justify-content: center;
        align-items: center;
        color: #fff;

        .pdf-name {
          width: 1.5rem;

          p {
            width: 100%;
            font-size: 0.18rem;
            /* 容器宽度 */
            white-space: nowrap;
            /* 防止文本换行 */
            overflow: hidden;
            /* 隐藏溢出的内容 */
            text-overflow: ellipsis;
            /* 使用省略号表示溢出的文本 */
            color: #fff;
          }

        }

        .pdf-list {
          // width: 100%;
          width: calc(100% - 1.5rem);
          height: 100%;
          display: flex;
          align-items: center;
          overflow: auto;
          // justify-content: flex-start;

          .pdf-box {
            width: 1.2rem;
            height: 0.4rem;
            // line-height: 0.4rem;
            background: #fff;
            //border: 1px solid #84B5FF;
            border-radius: 0.05rem;
            margin-right: 0.1rem;
            cursor: pointer;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
          }

          .active {
            border: none;
            background: #84b5ff;
            color: #fff;
          }
        }
      }

      .pdflook {
        overflow: auto;
        color: #fff;
        padding: 0 .1rem;

        /deep/p,
        h1,
        h2,
        h3,
        h4,
        h5,
        h6,
        div,
        li,
        tr {
          line-height: 2 !important;
          color: #fff;
        }
      }
    }
  }

}
</style>
<style scoped lang="less">
.sample-view {
  width: 100%;
  height: 40px;
  display: flex;
  align-items: center;

  img {
    height: 30px;
    margin-left: auto;
    position: relative;
    left: -10px;
    filter: hue-rotate(213deg) brightness(700%);
  }

  span {
    color: #999;
  }

  button {
    background: url('../zhinengkefu/imgs/btn1.png');
    background-size: 100% 100%;
    width: 84px;
    height: 32px;
    border: 0;
    color: #bdfff8;
    text-shadow: 0 0 2px #000;

    &:hover {
      filter: brightness(90%);
    }

    &.closeBtn {
      filter: hue-rotate(70deg) brightness(130%);
    }
  }
}

.sendBox-width1 {
  width: 100%;
}

.sendBox-width2 {
  width: 100%;
}

.sendBox {
  // width: 8rem;
  height: 0.5rem;
  // height: 50px;
  display: flex;
  align-items: center;
  box-shadow: 2px 4px 12px -9px #555;
  border-radius: 8px;
  border: 1px solid rgba(0, 0, 0, 0.16);
  background-color: #fff;

  &.disabled {
    .el-input {
      cursor: not-allowed;
    }

    .sendBtnm,
    .microphone {
      pointer-events: none;
    }
  }

  /deep/ .el-input {
    margin: 0 10px;
    height: 100%;
    color: #000;

    input {
      height: 100%;
      font-size: 15px;
      border: 0;
      background-color: transparent;
      padding: 0 5px;
      color: #000;
    }
  }

  .btn-inner {
    padding: 0 12px;
  }

  .btn-inner+.btn-inner {
    border-left: 1px solid #eee;
  }

  .huatong {
    width: 30px;
    min-width: 30px;
    height: 30px;
  }

  .sendBtn {
    width: 30px;
    min-width: 30px;
    height: 30px;
    cursor: pointer;

    img {
      height: 100%;
      width: 100%;
      object-fit: contain;
    }
  }
}

.dd-inner{
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 9;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(0, 6, 36, 0.6);
  
  /deep/ .loading-text{
    color: #fff;
  }
}

.upload-view{
  display: flex;
  align-items: center;
  border-top: 1px solid #fff;
  padding: 13px 0;
  
  img{
    width: 50px;
    height: 50px;
    object-fit: contain;
  }
  button{
    margin-left: 5px;
    color: #00e6ff;
  }
}
</style>